<template lang="pug">
.content
  //- div {{mappingTable}}
  el-table(highlight-current-row size="small"  height="350px" border :data="mappingTable")
    el-table-column(label="名称" prop="importColumnName")
    el-table-column(label="映射字段" v-slot="{row}")
      el-select(v-model="row.metaId" size="small")
        el-option(label="请选择" value="")
        el-option(v-for="item in dicList" :key="item.metaId" :label="item.columnDisplayName" :value="item.metaId")
  //-   el-table-column(
  //-     v-for="(value,key) in tableHeader"
  //-     :prop="key" :label="value" :key="key" v-slot="{row,column}")
  //- el-select(v-model="value" )
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";

export default {
  props: {
    excelData: {
      type: Array,
      default: () => []
    },
    tableName: {
      type: String,
      default: "LeaveFlow"
    }
  },
  data () {
    return {
      mappingTable: [],
      dicList: []
    };
  },
  computed: {
    tableHeader() {
      return this.excelData[0];
    },
    dataTabel() {
      return this.excelData.filter(({ index }) => index !== 0);
    }
    // mappingTable() {
    //   const array = [];
    //   for (const key in this.excelData[0]) {
    //     if (Object.hasOwnProperty.call(this.excelData[0], key)) {
    //       const element = this.excelData[0][key];
    //       console.log("element", element);
    //       array.push({ element, key, fielId: '' });
    //     }
    //   }
    //   return array;
    // }
  },
  mounted () {
    this.getFielIdDic();
    this.actionMap();
  },
  methods: {
    actionMap() {
      this.mappingTable = [];
      const array = [];
      for (const key in this.excelData[0]) {
        if (Object.hasOwnProperty.call(this.excelData[0], key)) {
          const importColumnName = this.excelData[0][key];
          console.log("element", importColumnName);
          array.push({ importColumnName, key, metaId: '' });
        }
      }
      console.log("array", array);
      this.mappingTable = array;
    },
    async getFielIdDic() {
      const res = await flowService.getColumnList(this.tableName);
      this.dicList = res.data;
    },
    getMappingList() {
      return this.mappingTable;
    }
  }
};
</script>

<style lang="scss" scoped></style>
